import React from "react";
import './App.css';
import Navigation from "./components/Navigation";
import HeroSection from "./components/Home";
import Destinations from "./components/Destinations";
import Packages from "./components/Packages";
import Testimonials from "./components/Testimonials";
import ContactForm from "./components/ContactForm";
import Footer from "./components/Footer";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import WhatsAppButton from "./components/whatsapp";

function App() {
  return (
    
    
      /* Navigate the navbar  */

     <BrowserRouter>
      <div className="app-container">
     <Navigation/>
     <div className="content-wrap">
     <Routes>
      
      <Route
          path="/"
          element={
            <>
              <HeroSection />
              <Destinations />
             
            </>
          }
        />
      
      <Route path="/about" element={<Testimonials/>}></Route>
      
      <Route path="/packages" element={<Packages/>}></Route>
      <Route path="/contact" element={<ContactForm/>}></Route>

     </Routes>
     
     </div>
      <WhatsAppButton />
     <Footer />
     </div>
     </BrowserRouter>
      
   
     

    
    
  );
}

export default App;